export default __webpack_public_path__ + "static/media/FormatoPresupuesto_invitacionpublica.6bf2c6e6.xlsx";